import axios from 'axios';
import ApiUrl from './config';

export async function printMedicalConclusion(): Promise<void> {
  const response = await axios.get(`${ApiUrl}/api/Documents/PrintMedicalConclusion`, {
    responseType: 'blob',
  });

  const blob = new Blob([response.data], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  window.open(url, '_blank');
  window.setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
}
